/** @format */

import {
	CriteoViewProductsResponse,
	CriteoDigitalShelfTalker,
	CriteoViewItemResponse
} from '@shared/data-access/interfaces';

export const EMPTY_CRITEO_DIGITAL_SHELF_TALKER: CriteoDigitalShelfTalker = {
	OnClickBeacon: '',
	OnLoadBeacon: '',
	OnViewBeacon: '',
	OnFileClickBeacon: '',
	OnBundleBasketChangeBeacon: '',
	LineItemID: '',
	rendering: {
		background_image: '',
		header_text: '',
		subcopy_text: '',
		button_text: '',
		redirect_url: '',
		text_color: ''
	}
};

/**
 * Used to initialize or reset the setCriteoProducts state to allow the
 * plp product list effect to run without making a call to Criteo.
 */
export const EMPTY_CRITEO_VIEW_PRODUCTS_RESPONSE: CriteoViewProductsResponse = {
	OnLoadBeacon: '',
	placements: [
		{
			carousel: [
				{
					OnClickBeacon: '',
					OnLoadBeacon: '',
					OnViewBeacon: '',
					format: '',
					rendering: '',
					products: []
				}
			]
		},
		{
			inGrid: [
				{
					OnClickBeacon: '',
					OnLoadBeacon: '',
					OnViewBeacon: '',
					format: '',
					rendering: '',
					products: []
				}
			]
		},
		{
			digitalShelfTalker: { ...EMPTY_CRITEO_DIGITAL_SHELF_TALKER }
		}
	]
};

export const EMPTY_CRITEO_VIEW_ITEM_RESPONSE: CriteoViewItemResponse = {
	OnLoadBeacon: '',
	placements: [
		{
			carousel: [
				{
					OnClickBeacon: '',
					OnLoadBeacon: '',
					OnViewBeacon: '',
					format: '',
					rendering: '',
					products: []
				}
			]
		}
	]
};

/* These are attributes necessary to render a pinned content component */
export const CRITEO_PINNED_CONTENT_REQUIRED_ATTRIBUTES = [
	'background_image',
	'redirect_url',
	'button_text',
	'header_text',
	'subcopy_text'
];

export const CRITEO_DIGITAL_SHELF_TALKER_POSITION = 5;
export const CRITEO_DIGITAL_SHELF_TALKER_PINNED_POSITION = 6;
